var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 300",
    style: {
      enableBackground: "new 0 0 500 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.3;fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n\t.st5{fill:url(#SVGID_6_);}\r\n\t.st6{fill:url(#SVGID_7_);}\r\n\t.st7{fill:url(#SVGID_8_);}\r\n\t.st8{fill:url(#SVGID_9_);}\r\n\t.st9{fill:url(#SVGID_10_);}\r\n\t.st10{fill:url(#SVGID_11_);}\r\n\t.st11{fill:url(#SVGID_12_);}\r\n\t.st12{fill:url(#SVGID_13_);}\r\n\t.st13{fill:url(#SVGID_14_);}\r\n\t.st14{fill:url(#SVGID_15_);}\r\n\t.st15{fill:url(#SVGID_16_);}\r\n\t.st16{fill:url(#SVGID_17_);}\r\n\t.st17{fill:url(#SVGID_18_);}\r\n\t.st18{fill:url(#SVGID_19_);}\r\n\t.st19{fill:url(#SVGID_20_);}\r\n\t.st20{fill:url(#SVGID_21_);}\r\n\t.st21{fill:url(#SVGID_22_);}\r\n\t.st22{fill:url(#SVGID_23_);}\r\n\t.st23{opacity:0.2;fill:url(#SVGID_24_);}\r\n\t.st24{opacity:0.2;fill:url(#SVGID_25_);}\r\n\t.st25{opacity:0.2;fill:url(#SVGID_26_);}\r\n\t.st26{opacity:0.2;fill:url(#SVGID_27_);}\r\n\t.st27{opacity:0.2;fill:url(#SVGID_28_);}\r\n\t.st28{opacity:0.2;fill:url(#SVGID_29_);}\r\n\t.st29{opacity:0.2;fill:url(#SVGID_30_);}\r\n\t.st30{opacity:0.2;fill:url(#SVGID_31_);}\r\n\t.st31{opacity:0.2;fill:url(#SVGID_32_);}\r\n\t.st32{opacity:0.2;fill:url(#SVGID_33_);}\r\n\t.st33{opacity:0.2;fill:url(#SVGID_34_);}\r\n\t.st34{opacity:0.2;fill:url(#SVGID_35_);}\r\n\t.st35{opacity:0.2;fill:url(#SVGID_36_);}\r\n\t.st36{opacity:0.2;fill:url(#SVGID_37_);}\r\n\t.st37{opacity:0.2;fill:url(#SVGID_38_);}\r\n\t.st38{opacity:0.2;fill:url(#SVGID_39_);}\r\n\t.st39{opacity:0.2;fill:url(#SVGID_40_);}\r\n\t.st40{fill:url(#SVGID_41_);}\r\n\t.st41{fill:url(#SVGID_42_);}\r\n\t.st42{fill:url(#SVGID_43_);}\r\n\t.st43{fill:url(#SVGID_44_);}\r\n\t.st44{fill:url(#SVGID_45_);}\r\n\t.st45{fill:url(#SVGID_46_);}\r\n\t.st46{fill:url(#SVGID_47_);}\r\n\t.st47{fill:url(#SVGID_48_);}\r\n\t.st48{fill:url(#SVGID_49_);}\r\n\t.st49{fill:url(#SVGID_50_);}\r\n\t.st50{fill:url(#SVGID_51_);}\r\n\t.st51{fill:url(#SVGID_52_);}\r\n\t.st52{fill:url(#SVGID_53_);}\r\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 250,
    cy: 250,
    r: 249.6872,
    gradientTransform: "matrix(1 0 0 0.6003 0 0.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2139,
    style: {
      stopColor: "#ECEDED",
      stopOpacity: 0.7861
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6433,
    style: {
      stopColor: "#BCBDBD",
      stopOpacity: 0.3567
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#909191",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0.63V300h500V0.63H0z M302.65,171.16c-15.91,22.55-39.86-28.69-54.83-2.8c-25.23-19.47-29.05-0.96-45.67,6 c6.14-9.31-13.65-19.62,6-21.01l-5.83-6.3c48.04-3.97,1.02-19.02-8.66-24.04c80.08,13.47,88.56-11.94,91.4-12.25 C318.47,139.37,297.17,122.4,302.65,171.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.0279,
    y1: 351.5455,
    x2: 344.9263,
    y2: 351.5455,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292.65,179.37c31.02-15.35-28.18-26.7,117.78,11.6c-33.78-12.2-78.44-14.71-109.91-35.9 C298.23,159.31,318.92,156.95,292.65,179.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 302.8973,
    y1: 319.6331,
    x2: 333.5027,
    y2: 319.6331,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M299.49,183.87c5.2-6.35,13.12-9.92,20.34-17.37c-0.39,5.19-7.32,7.31-12.28,12.46 c5.52-1.6,8.98-4.35,32.23-7.9c-50.03,9.77-15.58,5.62-20.11,26.04C316.31,185.26,313.48,178.18,299.49,183.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.5018,
    y1: 325.3207,
    x2: 339.6007,
    y2: 325.3207,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M249.32,161.66c-2.94,4.87-7.22,36.28-13.33,37.82c35.99-3.38,58.52-14.14,66.48-13.02 c11.12,6.65,111.99,66.93,112.18,67.04C291.57,180.98,268.32,153.98,249.32,161.66z M265.75,163.77 c66.71,30.28-8.01,30.52-26.17,32.03C257.13,170.04,243.39,162.29,265.75,163.77z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.5849,
    y1: 205.8207,
    x2: 301.4327,
    y2: 205.8207,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M239.32,198.57c-20.86,13.99-37.3,60.57-67,63.83l0,0C196.2,263.35,225.74,213.1,239.32,198.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.8923,
    y1: 164.2374,
    x2: 340.7956,
    y2: 164.2374,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M247.82,165.16c-24.14-21.18-54.11,22.68-38.83,0.16c-33.8,31.36-90.48,81.4-128.33,110.79 C219.9,167.54,212.4,148.19,247.82,168.36V165.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.1367,
    y1: 231.147,
    x2: 339.5293,
    y2: 231.147,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M239.49,169.86c-1.9-1.07-7.6-0.36-16.63-9.39C222.17,163.81,228.95,167.2,239.49,169.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.5361,
    y1: 219.7544,
    x2: 332.5271,
    y2: 219.7544,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M226.65,171.46c-1.39-0.53-1.32,0.36-13.8-3.99C214.66,169.23,214.73,169.43,226.65,171.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.2921,
    y1: 137.6236,
    x2: 254.7052,
    y2: 137.6236,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M119.99,245.29c-2.76,6.61,18.11,23.59,37.15,20.18C156.48,271.17,108.09,255.83,119.99,245.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.1351,
    y1: 151.8719,
    x2: 367.1522,
    y2: 151.8719,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M80.65,173.86c25.24-4.45,86.53-14.88,110.83-17.61c-36.62-8.84-67.38-23.62-112.17-22.11 c57.13-5.74,135.58,38.2,123.52,13.84c2.04-4.57-76.35-10.05-76.35-11.44c53.94,4.06,94.74,18.1,88.33-3.7 c20.46,5.51,3.9,16.22-9.67,13.81C225.83,163.13,84.03,168.42,80.65,173.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 315.2924,
    y1: 182.0699,
    x2: 339.7254,
    y2: 182.0699,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M168.5,160.46c7.32,1.21,16.4-3.3,0.86,24.14c1.49,2.04,9.98-25.02,16.28-21.62 c1.39,0.46,0.75,7.53,9.99,2.9C175.87,166.78,214,159,168.5,160.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.8553,
    y1: 196.0491,
    x2: 342.842,
    y2: 196.0491,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M192.49,157.16c9.09,4.18,4.78,4.12-9.51,28.99c6.75-5.5,9.9-25.43,26.15-21.46 C201.75,165.69,201.15,157.2,192.49,157.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.8695,
    y1: 162.8291,
    x2: 337.7284,
    y2: 162.8291,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M154.32,162.36c5.12,0.03,9.92,10.72,17.02,13.77C166.71,173.13,163.23,161.13,154.32,162.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.017,
    y1: 188.3171,
    x2: 333.1447,
    y2: 188.3171,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M189.15,166.86c-2.33,1.48,0.82,8.51,0.21,8.1C188.55,174.29,185.04,166.6,189.15,166.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 365.4515,
    y1: 180.7377,
    x2: 418.9607,
    y2: 180.7377,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M195.56,123.51c4.85,2.94,15.8,5.61,20.93,11.04c-31.58-15.82-65.77-31.83-99.28-53.51 c38.19,17.66,61.11,47.98,127.07,44.81c-12.44,3.9-29.13-1.7-48.62-3.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.0551,
    y1: 257.3886,
    x2: 472.4802,
    y2: 257.3886,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M238.32,125.94c-16.83-19.95,9.58-16.93-39.19-98.43c69.85,85.86-13.77,155.27,116.52,18.47 C313.32,39.6,262.55,116.73,238.32,125.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.9225,
    y1: 299.7915,
    x2: 451.4265,
    y2: 299.7915,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M278.9,84.08c11.44-6.9,16.68-22.83,41.77-35.5C303.35,55.06,293.92,72.23,278.9,84.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.4893,
    y1: 329.9031,
    x2: 474.5948,
    y2: 329.9031,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M246.9,126.55c25.47,9.26,59.16-49.93,166-101.14C314.98,67.59,271.2,135.04,246.9,126.55z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.7078,
    y1: 257.1382,
    x2: 379.3059,
    y2: 257.1382,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M250.15,120.84c2.89-1.05,6.82,3.77,13.97,4.09C259.86,125.95,259.66,124.89,250.15,120.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 375.9299,
    y1: 261.9883,
    x2: 378.5614,
    y2: 261.9883,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M256.9,123.84c2.88,0.69,0.95-0.22,10.17-2.38C266.08,121.13,264.85,124.07,256.9,123.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.0054,
    y1: 306.3787,
    x2: 390.1118,
    y2: 306.3787,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M284.9,109.89c8.28,6.45,4.14,25.02,42.95,5.23C314.86,116.05,302.46,136.03,284.9,109.89z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.4277,
    y1: 359.6252,
    x2: 461.7399,
    y2: 359.6252,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M310.12,141.64c-3.25,3.31,7.75-1.31,51.78,18.66c-0.88,3.61-61.77-30.27-52.22-7.4 c-19.24-28.11,82.89-86.2,110.57-114.64c-33.32,35.3-82.31,57.65-111.62,100.4c1.09-0.47,0.06,0.27,10.6-3.53 c-2.27,0.89-4.6,1.96-9.46,4.43c2.42-0.51-0.71,1.28,35.14-0.01c-12.9,2.32-31.71-3.24-45.21,7.72c1.76-1.46,8.78-2.14,9.97-7.32 c-2.85,1.06-0.2-0.28-10.64,1.57C300.26,141.77,306.14,137.24,310.12,141.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.6407,
    y1: 303.2025,
    x2: 359.178,
    y2: 303.2025,
    gradientTransform: "matrix(0 -1 1 0 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M307.32,160.36c-3.03-2.53-12.86-2.69-5.65-19.54C297.89,145.61,304.3,159.63,307.32,160.36z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_24_",
    cx: 766.5458,
    cy: 310.3719,
    r: 3.5065,
    gradientTransform: "matrix(7.1282 4.9501 -4.3516 -0.3499 -3973.0232 -3589.7744)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    style: {
      stopColor: "#EBEBEB",
      stopOpacity: 0.9646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1268,
    style: {
      stopColor: "#BCBBBC",
      stopOpacity: 0.8732
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2238,
    style: {
      stopColor: "#939192",
      stopOpacity: 0.7762
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#716E6F",
      stopOpacity: 0.6753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    style: {
      stopColor: "#545152",
      stopOpacity: 0.5695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#3E3B3C",
      stopOpacity: 0.4568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#2F2B2C",
      stopOpacity: 0.3343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#262223",
      stopOpacity: 0.1946
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M165.87,113.61c-9.17-1.01-42.24-14.51-53.83-31.88C107.04,66.52,188.34,111.46,165.87,113.61z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_25_",
    cx: 759.0049,
    cy: 364.1534,
    r: 3.511,
    gradientTransform: "matrix(10.7218 1.1795 -3.7576 1.363 -6545.5806 -1265.4288)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    style: {
      stopColor: "#EBEBEB",
      stopOpacity: 0.9646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1268,
    style: {
      stopColor: "#BCBBBC",
      stopOpacity: 0.8732
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2238,
    style: {
      stopColor: "#939192",
      stopOpacity: 0.7762
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#716E6F",
      stopOpacity: 0.6753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    style: {
      stopColor: "#545152",
      stopOpacity: 0.5695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#3E3B3C",
      stopOpacity: 0.4568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#2F2B2C",
      stopOpacity: 0.3343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#262223",
      stopOpacity: 0.1946
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M262.04,130.23c-4.49,3.37-70.65,3.34-76.85-6.8C181.01,116.66,277.77,120.81,262.04,130.23z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_26_",
    cx: 758.0776,
    cy: 363.4068,
    r: 3.511,
    gradientTransform: "matrix(10.7218 1.1795 -3.7576 1.363 -6545.5806 -1265.4288)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    style: {
      stopColor: "#EBEBEB",
      stopOpacity: 0.9646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1268,
    style: {
      stopColor: "#BCBBBC",
      stopOpacity: 0.8732
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2238,
    style: {
      stopColor: "#939192",
      stopOpacity: 0.7762
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#716E6F",
      stopOpacity: 0.6753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    style: {
      stopColor: "#545152",
      stopOpacity: 0.5695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#3E3B3C",
      stopOpacity: 0.4568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#2F2B2C",
      stopOpacity: 0.3343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#262223",
      stopOpacity: 0.1946
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M254.91,128.12c-4.49,3.37-70.65,3.34-76.85-6.8C173.87,114.55,270.63,118.7,254.91,128.12z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_27_",
    cx: 767.0709,
    cy: 205.3407,
    r: 3.4708,
    gradientTransform: "matrix(1.3564 6.5219 -4.09 -1.8206 103.5386 -4477.3999)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    style: {
      stopColor: "#EBEBEB",
      stopOpacity: 0.9646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1268,
    style: {
      stopColor: "#BCBBBC",
      stopOpacity: 0.8732
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2238,
    style: {
      stopColor: "#939192",
      stopOpacity: 0.7762
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#716E6F",
      stopOpacity: 0.6753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    style: {
      stopColor: "#545152",
      stopOpacity: 0.5695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#3E3B3C",
      stopOpacity: 0.4568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#2F2B2C",
      stopOpacity: 0.3343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#262223",
      stopOpacity: 0.1946
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M308.16,173.84c-4.79-2.09-12.32-10.5-16.44-20.74C274.21,83.81,345.59,173.52,308.16,173.84z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_28_",
    cx: 767.6683,
    cy: 205.3116,
    r: 3.4708,
    gradientTransform: "matrix(1.3564 6.5219 -4.09 -1.8206 103.5386 -4477.3999)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    style: {
      stopColor: "#EBEBEB",
      stopOpacity: 0.9646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1268,
    style: {
      stopColor: "#BCBBBC",
      stopOpacity: 0.8732
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2238,
    style: {
      stopColor: "#939192",
      stopOpacity: 0.7762
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#716E6F",
      stopOpacity: 0.6753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    style: {
      stopColor: "#545152",
      stopOpacity: 0.5695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#3E3B3C",
      stopOpacity: 0.4568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#2F2B2C",
      stopOpacity: 0.3343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#262223",
      stopOpacity: 0.1946
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M309.09,177.78c-4.79-2.09-12.32-10.5-16.44-20.74C275.14,87.76,346.52,177.47,309.09,177.78z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_29_",
    cx: 770.845,
    cy: 206.3651,
    r: 3.4708,
    gradientTransform: "matrix(1.3564 6.5219 -4.09 -1.8206 103.5386 -4477.3999)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    style: {
      stopColor: "#EBEBEB",
      stopOpacity: 0.9646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1268,
    style: {
      stopColor: "#BCBBBC",
      stopOpacity: 0.8732
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2238,
    style: {
      stopColor: "#939192",
      stopOpacity: 0.7762
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#716E6F",
      stopOpacity: 0.6753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    style: {
      stopColor: "#545152",
      stopOpacity: 0.5695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#3E3B3C",
      stopOpacity: 0.4568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#2F2B2C",
      stopOpacity: 0.3343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#262223",
      stopOpacity: 0.1946
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M309.09,196.59c-4.79-2.09-12.32-10.5-16.44-20.74C275.14,106.56,346.52,196.27,309.09,196.59z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_30_",
    cx: 773.3531,
    cy: 264.6894,
    r: 3.5057,
    gradientTransform: "matrix(5.3521 5.7339 -4.9316 -0.7608 -2541.5737 -4118.2915)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    style: {
      stopColor: "#EBEBEB",
      stopOpacity: 0.9646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1268,
    style: {
      stopColor: "#BCBBBC",
      stopOpacity: 0.8732
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2238,
    style: {
      stopColor: "#939192",
      stopOpacity: 0.7762
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#716E6F",
      stopOpacity: 0.6753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    style: {
      stopColor: "#545152",
      stopOpacity: 0.5695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#3E3B3C",
      stopOpacity: 0.4568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#2F2B2C",
      stopOpacity: 0.3343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#262223",
      stopOpacity: 0.1946
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M311.3,134.94c-10.48-1.36-45.13-22.66-43.42-38.56C274.7,83.63,338.16,134.77,311.3,134.94z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_31_",
    cx: 773.9163,
    cy: 265.3006,
    r: 3.5057,
    gradientTransform: "matrix(5.3521 5.7339 -4.9316 -0.7608 -2541.5737 -4118.2915)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    style: {
      stopColor: "#EBEBEB",
      stopOpacity: 0.9646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1268,
    style: {
      stopColor: "#BCBBBC",
      stopOpacity: 0.8732
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2238,
    style: {
      stopColor: "#939192",
      stopOpacity: 0.7762
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#716E6F",
      stopOpacity: 0.6753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    style: {
      stopColor: "#545152",
      stopOpacity: 0.5695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#3E3B3C",
      stopOpacity: 0.4568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#2F2B2C",
      stopOpacity: 0.3343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#262223",
      stopOpacity: 0.1946
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M311.3,137.71c-10.48-1.36-45.13-22.66-43.42-38.56C274.7,86.39,338.16,137.53,311.3,137.71z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_32_",
    cx: 758.9492,
    cy: 377.9315,
    r: 3.511,
    gradientTransform: "matrix(10.7218 1.1795 -3.7576 1.363 -6545.5806 -1265.4288)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    style: {
      stopColor: "#EBEBEB",
      stopOpacity: 0.9646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1268,
    style: {
      stopColor: "#BCBBBC",
      stopOpacity: 0.8732
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2238,
    style: {
      stopColor: "#939192",
      stopOpacity: 0.7762
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#716E6F",
      stopOpacity: 0.6753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    style: {
      stopColor: "#545152",
      stopOpacity: 0.5695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#3E3B3C",
      stopOpacity: 0.4568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#2F2B2C",
      stopOpacity: 0.3343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#262223",
      stopOpacity: 0.1946
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M209.67,148.94c-4.49,3.37-70.65,3.34-76.85-6.8C128.64,135.38,225.4,139.53,209.67,148.94z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_33_",
    cx: 739.881,
    cy: 385.1685,
    r: 3.436,
    gradientTransform: "matrix(10.6697 -1.339 -2.6214 2.1141 -6727.2725 340.1161)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    style: {
      stopColor: "#EBEBEB",
      stopOpacity: 0.9646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1268,
    style: {
      stopColor: "#BCBBBC",
      stopOpacity: 0.8732
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2238,
    style: {
      stopColor: "#939192",
      stopOpacity: 0.7762
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#716E6F",
      stopOpacity: 0.6753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    style: {
      stopColor: "#545152",
      stopOpacity: 0.5695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#3E3B3C",
      stopOpacity: 0.4568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#2F2B2C",
      stopOpacity: 0.3343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#262223",
      stopOpacity: 0.1946
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M194,159.18c-0.47,5.68-90.06,21.63-72.75,8.29C127.29,161.49,201.81,148.4,194,159.18z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_34_",
    cx: 667.425,
    cy: 270.1629,
    r: 3.4381,
    gradientTransform: "matrix(4.0025 -6.0859 1.5008 2.4766 -2891.7227 3575.3459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    style: {
      stopColor: "#EBEBEB",
      stopOpacity: 0.9646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1268,
    style: {
      stopColor: "#BCBBBC",
      stopOpacity: 0.8732
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2238,
    style: {
      stopColor: "#939192",
      stopOpacity: 0.7762
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#716E6F",
      stopOpacity: 0.6753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    style: {
      stopColor: "#545152",
      stopOpacity: 0.5695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#3E3B3C",
      stopOpacity: 0.4568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#2F2B2C",
      stopOpacity: 0.3343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#262223",
      stopOpacity: 0.1946
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M199.05,161.33c6.68,6.2-17.16,52.06-27.88,42.4C164.48,197.53,188.33,151.68,199.05,161.33z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_35_",
    cx: 672.5275,
    cy: 290.4572,
    r: 3.4381,
    gradientTransform: "matrix(4.0025 -6.0859 1.5008 2.4766 -2891.7227 3575.3459)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    style: {
      stopColor: "#EBEBEB",
      stopOpacity: 0.9646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1268,
    style: {
      stopColor: "#BCBBBC",
      stopOpacity: 0.8732
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2238,
    style: {
      stopColor: "#939192",
      stopOpacity: 0.7762
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#716E6F",
      stopOpacity: 0.6753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    style: {
      stopColor: "#545152",
      stopOpacity: 0.5695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#3E3B3C",
      stopOpacity: 0.4568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#2F2B2C",
      stopOpacity: 0.3343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#262223",
      stopOpacity: 0.1946
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M249.93,180.54c6.68,6.2-17.16,52.06-27.88,42.4C215.36,216.74,239.21,170.89,249.93,180.54z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_36_",
    cx: 675.0361,
    cy: 309.196,
    r: 3.441,
    gradientTransform: "matrix(6.4386 -5.2796 0.4076 2.624 -4348.4873 2993.9636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    style: {
      stopColor: "#EBEBEB",
      stopOpacity: 0.9646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1268,
    style: {
      stopColor: "#BCBBBC",
      stopOpacity: 0.8732
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2238,
    style: {
      stopColor: "#939192",
      stopOpacity: 0.7762
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#716E6F",
      stopOpacity: 0.6753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    style: {
      stopColor: "#545152",
      stopOpacity: 0.5695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#3E3B3C",
      stopOpacity: 0.4568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#2F2B2C",
      stopOpacity: 0.3343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#262223",
      stopOpacity: 0.1946
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M146.25,222.96c4.14,6.53-38.69,48.08-44.85,36.79C97.27,253.21,140.09,211.68,146.25,222.96z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_37_",
    cx: 647.382,
    cy: 248.8896,
    r: 3.4252,
    gradientTransform: "matrix(3.0242 -4.2333 1.6426 2.1005 -2153.8269 2357.5745)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    style: {
      stopColor: "#EBEBEB",
      stopOpacity: 0.9646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1268,
    style: {
      stopColor: "#BCBBBC",
      stopOpacity: 0.8732
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2238,
    style: {
      stopColor: "#939192",
      stopOpacity: 0.7762
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#716E6F",
      stopOpacity: 0.6753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    style: {
      stopColor: "#545152",
      stopOpacity: 0.5695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#3E3B3C",
      stopOpacity: 0.4568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#2F2B2C",
      stopOpacity: 0.3343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#262223",
      stopOpacity: 0.1946
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M223.34,125.04c6.78,6.64-10.77,38.06-21.06,29.5C195.5,147.89,213.05,116.48,223.34,125.04z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_38_",
    cx: 683.3285,
    cy: 334.3019,
    r: 3.4268,
    gradientTransform: "matrix(4.787 -3.5999 0.6552 2.2868 -3186.7031 1872.3601)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    style: {
      stopColor: "#EBEBEB",
      stopOpacity: 0.9646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1268,
    style: {
      stopColor: "#BCBBBC",
      stopOpacity: 0.8732
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2238,
    style: {
      stopColor: "#939192",
      stopOpacity: 0.7762
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#716E6F",
      stopOpacity: 0.6753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    style: {
      stopColor: "#545152",
      stopOpacity: 0.5695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#3E3B3C",
      stopOpacity: 0.4568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#2F2B2C",
      stopOpacity: 0.3343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#262223",
      stopOpacity: 0.1946
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M320.1,164.37c3.85,7.12-27.11,35.06-33.35,25.08C282.9,182.33,313.86,154.4,320.1,164.37z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_39_",
    cx: 684.4811,
    cy: 337.4791,
    r: 3.4268,
    gradientTransform: "matrix(4.787 -3.5999 0.6552 2.2868 -3186.7031 1872.3601)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    style: {
      stopColor: "#EBEBEB",
      stopOpacity: 0.9646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1268,
    style: {
      stopColor: "#BCBBBC",
      stopOpacity: 0.8732
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2238,
    style: {
      stopColor: "#939192",
      stopOpacity: 0.7762
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#716E6F",
      stopOpacity: 0.6753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    style: {
      stopColor: "#545152",
      stopOpacity: 0.5695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#3E3B3C",
      stopOpacity: 0.4568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#2F2B2C",
      stopOpacity: 0.3343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#262223",
      stopOpacity: 0.1946
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M327.7,167.48c3.85,7.12-27.11,35.06-33.35,25.08C290.5,185.45,321.45,157.52,327.7,167.48z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_40_",
    cx: 766.9181,
    cy: 406.8416,
    r: 3.5612,
    gradientTransform: "matrix(12.0521 1.5663 -3.9461 0.9456 -7459.6704 -1443.2489)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    style: {
      stopColor: "#EBEBEB",
      stopOpacity: 0.9646
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1268,
    style: {
      stopColor: "#BCBBBC",
      stopOpacity: 0.8732
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2238,
    style: {
      stopColor: "#939192",
      stopOpacity: 0.7762
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3247,
    style: {
      stopColor: "#716E6F",
      stopOpacity: 0.6753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    style: {
      stopColor: "#545152",
      stopOpacity: 0.5695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5432,
    style: {
      stopColor: "#3E3B3C",
      stopOpacity: 0.4568
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#2F2B2C",
      stopOpacity: 0.3343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8054,
    style: {
      stopColor: "#262223",
      stopOpacity: 0.1946
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M219.96,148.21c-3.73,2.53-78.4-0.85-86.07-9.93C132.59,132.95,225.9,139.15,219.96,148.21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.0073,
    y1: 217.843,
    x2: 273.0073,
    y2: 161.5155
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M261.67,161.52c1.72,0.03-1.21,13.69,22.68,56.33c-1.63-9.39-17.16-8.07-22.35-55.66 C262,162.23,261.66,161.47,261.67,161.52z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.0037,
    y1: 189.2684,
    x2: 223.0037,
    y2: 157.7157
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M229,157.72c-1.46,9.68-7.82,19.06-12.02,31.55C220.26,181.39,229.55,169.53,229,157.72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.2816,
    y1: 193.875,
    x2: 254.2816,
    y2: 162.9179
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M253,162.92c1.78,9.85,0.5,8.88,1.01,30.96C256.84,184.66,255.37,172.98,253,162.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.7256,
    y1: 254.5801,
    x2: 195.7256,
    y2: 208.1368
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M229.33,208.14c-20.27,14.93-43.59,30.52-67.22,46.44C185,242.99,207.11,224.09,229.33,208.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.4537,
    y1: 240.1238,
    x2: 321.4537,
    y2: 184.7829
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M295.67,185.13c-0.16-0.1-0.29-0.22-0.37-0.34c17.46,16.63,30.69,37.91,52.32,55.34 C325.7,228.24,314.85,203.7,295.67,185.13z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.4618,
    y1: 113.6974,
    x2: 378.4618,
    y2: 70.0008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M328,113.7c31.44-14.54,65.59-30.41,100.92-43.7C395.45,74.89,364.57,98.92,328,113.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 302.8007,
    y1: 140.7086,
    x2: 302.8007,
    y2: 122.8805
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M301,140.71c-0.15-1.9,0.15-0.33,3-17.83C302.5,123.82,307.95,131.22,301,140.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.4982,
    y1: 126.9029,
    x2: 248.4982,
    y2: 58.0534
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M239,126.9c13.34-20.77-6.93-21.49,19-68.85C251.92,76.16,245.94,99.34,239,126.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.9626,
    y1: 124.5019,
    x2: 195.9626,
    y2: 92.9011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M214,124.5c-14.88-4.22-25.85-16.62-36.07-31.6C184.68,99.47,199.6,122.42,214,124.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.8681,
    y1: 141.3488,
    x2: 130.8681,
    y2: 80.0266
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M214,140.71c-54.44-23.15-113.13-39.13-171.69-60.68c50.9,25.25,121.17,38.77,177.12,61.32 C217.75,141.04,216.02,140.77,214,140.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.9786,
    y1: 258.1624,
    x2: 194.9786,
    y2: 171.3214
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M245,171.32c-74.66,94.58-88.67,41.44-100.04,86.84C174.15,207.78,163.72,275.79,245,171.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.0399,
    y1: 204.8468,
    x2: 124.0399,
    y2: 165.9192
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M178,165.92c-20.21,23.67-78.17,21-107.92,38.93C71.71,201.55,172.96,183.68,178,165.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.8488,
    y1: 168.3123,
    x2: 373.8488,
    y2: 151.5132
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0914,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2742,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3817,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.7027
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4785,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7258,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M308,151.51c39.04,15.82,86.43,15.93,131.7,15.61C401.36,164.36,381.54,178.23,308,151.51z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/glass.3181d9252b4ccdadd9615844fad527f9.svg";
export { ForwardRef as ReactComponent };